module.exports = __webpack_public_path__ + "img/comando-de-voz.b095ad61.svg";